import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Summary = _resolveComponent("Summary")!

  return (_openBlock(), _createBlock(_component_Summary, {
    "date-from": _ctx.dateFrom,
    "date-to": _ctx.dateTo,
    imei: _ctx.imei,
    vehicle: _ctx.vehicle
  }, null, 8, ["date-from", "date-to", "imei", "vehicle"]))
}